<template>
  <div class="outer-container">
    <div class="container">
      <div class="inner-container">
        <div>
          <img src="../../assets/bongo/Group 3125.png" alt="" />
        </div>
        <div class="flex-right">
          <div class="upper">
            <img src="../../assets/bongo/“ (1).svg" alt="" />
            <div class="div" style="padding:20px 0"></div>

            <h3 class="" style="color: #29292B">
              At Bongo we believe in human centric designs because people ignore
              design that ignores people. We are very excited to team up with
              Upskill in our mission to recruit the very best talents from all
              walks of life. We welcome anyone who wants to solve problems that
              impact millions of users and be part of a team that is empowered
              to do so.
            </h3>
            <div class="div" style="padding:20px 0"></div>
          </div>
          <div class="lower">
            <h2>
              Shadid Haque
            </h2>
            <h5>
              Chief Technology Officer at Bongo
            </h5>
            <img
              src="../../assets/bongo/“ (2) (1).svg"
              alt=""
              style="text-align:right"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.credits {
  font: 400 0.75rem/1rem 'Manrope';
  color: #626367;
}
.inner-container {
  max-width: 1270px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 2fr;
  padding-bottom: 100px;
}
.flex-right {
  display: flex;
  flex-direction: column;
}
.upper,
.lower {
  padding: 0 50px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.flex-right h3 {
  font: 400 1rem/1.2rem 'Manrope';
  color: white;
}

.lower h2 {
  font: 700 1.5rem/1.75rem 'Manrope';
  color: #29292b;
}
.lower h5 {
  font: 400 0.875rem/1rem 'Manrope';
  color: #29292b;
}

.lower {
  margin-top: -50px;
  display: flex;
  flex-direction: column;
}
.lower img {
  align-self: flex-end;
}
.video {
  width: 849px;
  height: 478px;
}
@media only screen and (max-width: 600px) {
  .inner-container {
    max-width: 1270px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr;
    padding-bottom: 100px;
  }
  .video {
    width: 359px;
    height: 278px;
  }
  .upper img {
    padding-bottom: 25px;
  }
  .lower img {
    padding-top: 20px;
  }
}
</style>
